import script from "./ControlPageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlPageTab.vue?vue&type=script&setup=true&lang=ts"

import "./ControlPageTab.vue?vue&type=style&index=0&id=778651a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778651a8"]])

export default __exports__